import { PreviewComponent } from './components/preview/preview.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainComponent } from './components/main/main.component';

const routes: Routes = [
  {
    path: ':id',
    component: MainComponent,
    data: {
      title: 'Start New Campaign',
      page_name: 'start_a_fundraiser',
      category: 'start fundraiser',
      lastOrderSkip: true
    }
  },
  {
    path: 'preview/:id',
    component: PreviewComponent,
    data: {
      title: 'Campaign Preview',
      page_name: 'fundraiser_preview',
      category: 'crowdfunding',
      lastOrderSkip: true
    }
  },
  {
    path: '**',
    redirectTo: 'basic'
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MedicalCampaignRoutingModule { }
